import AuthoringExperiments from 'bundles/epic/clients/Authoring';
import { PLATFORM_ONLY_ITEM_TYPES } from 'bundles/item-authoring/shared/platformOnlyItemTypes';
import type { ItemType } from 'bundles/item/types/ItemType';

// https://tools.coursera.org/epic/experiment/HJG-kI6uEeyAw9c5depHlw
export const isItemAuthoringFrameworkEnabledForType = (itemType: ItemType): boolean => {
  if (!itemType) {
    return false;
  }

  return (
    AuthoringExperiments.get('enabledItemAuthoringFrameworkTypes').includes?.(itemType) ||
    PLATFORM_ONLY_ITEM_TYPES.includes(itemType)
  );
};

export const isCompareItemVersionsEnabledForType = (itemType?: ItemType): boolean => {
  if (!itemType) {
    return false;
  }

  return AuthoringExperiments.get('enabledCompareItemVersionTypes').includes?.(itemType);
};

// https://tools.coursera.org/epic/experiment/JMozP91wEe2TRhJQjI_Svw
export const isCourseBuilderPilotEnabled = (partnerId?: number) => {
  if (AuthoringExperiments.get('courseBuilderByUserOverride')) {
    return true;
  }

  if (!partnerId) {
    return false;
  }

  return partnerId && AuthoringExperiments.get('courseBuilderPilotPartners').includes(partnerId);
};

// https://tools.coursera.org/epic/experiment/TODO
export const isExperimentalCourseBuilderItemTypesEnabled = () => {
  return AuthoringExperiments.get('enableExperimentalCourseBuilderItemTypes');
};

export const isEmbedPdfInReadingEnabled = () => {
  return AuthoringExperiments.get('enablePdfEmbedInReading');
};

// https://tools.coursera.org/epic/experiment/7sVZ0i_iEe-u9A5PYmkxww
export const isCbSyllabusFlowEnabled = () => {
  return AuthoringExperiments.get('enableCbSyllabusFlow');
};

// https://tools.coursera.org/epic/experiment/JMXFmwefEe-nlw5rS2MojQ
export const isModuleReuseEnabled = () => {
  return AuthoringExperiments.get('enableModuleReuse');
};

// https://tools.coursera.org/epic/experiment/pva-NPErEe6PRg7CBHvMLQ
export const isPluginUpdatedUiEnabled = () => {
  return AuthoringExperiments.get('enablePluginUpdatedUi');
};

export const isV2PluginItemAuthoringEnabled = () => {
  return AuthoringExperiments.get('enableV2PluginItemAuthoring');
};
